/**
 * Copy-to-clipboard for [data-copy] elements.
 *
 * Usage: add data-copy="value" and uk-tooltip="title: Copy" to any element.
 * On click the value is copied and the tooltip briefly reads "Copied!".
 */
export default function initClipboard() {
    document.addEventListener('click', e => {
        const el = e.target.closest('[data-copy]');
        if (!el) return;

        const value = el.dataset.copy;
        if (!value) return;

        const copy = () => {
            const tip = UIkit.tooltip(el, { title: 'Copied!', delay: 0 }); // eslint-disable-line no-undef
            tip.show();
            setTimeout(() => {
                tip.hide();
                tip.$props.title = 'Copy';
            }, 1500);
        };

        if (navigator.clipboard) {
            navigator.clipboard.writeText(value).then(copy);
        } else {
            // Fallback for older browsers
            const ta = document.createElement('textarea');
            ta.value = value;
            ta.style.cssText = 'position:fixed;opacity:0;pointer-events:none';
            document.body.appendChild(ta);
            ta.select();
            document.execCommand('copy'); // eslint-disable-line no-undef
            ta.remove();
            copy();
        }
    });
}
